export const ACCESS_LEVEL_VIEW = "view";
export const ACCESS_LEVEL_NONE = "none";
export const ACCESS_LEVEL_PURCHASE = "purchase";
